// extracted by mini-css-extract-plugin
export default {"icon":"Travel_icon__fTNSR"};